import { FC } from 'react'
import styled from 'styled-components'
import spinner from './spinner.png'

const LoadingWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Loading: FC = () => (
  <LoadingWrapper>
    <img src={spinner} alt="" />
  </LoadingWrapper>
)

export default Loading
